module.exports = __webpack_public_path__ + "59f3d0fdbd7b67e5ebefb5123d765349.svg";